import { HIDE_LOADER, SHOW_LOADER ,LOGOUT_SUCCESS} from "../actions/types";

const initialState = {
  isLoading: false,
};

export default function loaders(state = initialState, { payload, type }) {
  switch (type) {
    case HIDE_LOADER:
      return { ...state,  isLoading: false,  };

    case SHOW_LOADER:
      return {  ...state,  isLoading: true,  };

    case LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
}
